import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import API from "../../api/API";
import { getErrorMessage } from "../../../utils/GeneralUtils";
import { useAtomValue } from "jotai";
import { tenantIDAtom } from "../../../atoms/GlobalAtoms";
import { newToastEvent } from "../../../utils/ToastUtil";

// Used to a delete cloud - uses non permanent delete endpoint currently
// On successful delete, the user is redirected to the cloud switcher page.
const useDeleteCloud = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const tenantID = useAtomValue(tenantIDAtom);

  const goToCloudsPage = () => navigate("/clouds");

  const deleteCloud = useMutation({
    mutationFn: ({ cloudID }: { cloudID: string }) => {
      if (!cloudID) {
        return Promise.reject("Failed to delete cloud: No ID provided.");
      }

      return API.deleteCloudTenant(cloudID);
    },
    onSuccess: (_, { cloudID }) => {
      queryClient.setQueryData(["clouds"], (prev: any) => {
        if (!Array.isArray(prev)) return prev;

        const newClouds = prev.filter((t: any) => t?.TenantID !== cloudID);

        return newClouds;
      });

      queryClient.setQueriesData({ queryKey: ["user"] }, (prev: any) => {
        if (!prev || !prev?.user?.Tenants) return prev;

        const newTenants = prev.user.Tenants.filter(
          (t: any) => t?.TenantID !== cloudID
        );

        return { ...prev, user: { ...prev.user, Tenants: newTenants } };
      });

      newToastEvent("success", "Successfully deleted cloud.");

      if (tenantID === cloudID) {
        goToCloudsPage();
      }
    },
  });

  return {
    deleteCloud: deleteCloud.mutate,
    deletingCloud: deleteCloud.isPending,
    deleteCloudError: deleteCloud.error
      ? getErrorMessage(deleteCloud.error)
      : null,
  };
};

export default useDeleteCloud;
